export const AUTH_MODULE = "auth"
export const SERVICE_NAME = "auth/login"
export const LOGIN_MODEL = {
    email: '',
    password: '',
    isSubmitting: false
    // role:''
    }
